<form #f="ngForm" (ngSubmit)="f.form.valid && onClickConfirmButton()" appFocusFirstElement class="w-100">
  <h2 mat-dialog-title>{{'title.select_number_phone' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onClickCancelButton()" cdkFocusInitial>
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <mat-dialog-content>
    <div class="row mt-3">
      <div class="col-md-12">
        <mat-form-field class="w-100">
          <mat-label>{{'form.phone' | translate}}</mat-label>
          <mat-select (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false" (focus)="commonService.openComboBox(checkFocus, phoneNumberSelect)" id="numberPhone"
           [(ngModel)]="selectedPhone" name="numberPhone" #numberPhoneRe="ngModel" #phoneNumberSelect
            [ngClass]="{ 'is-invalid': f.submitted && numberPhoneRe.invalid }" required>
            <mat-option [value]="null">{{'form.select_cert' | translate}}</mat-option>
            <mat-option *ngFor="let item of numberPhones" [value]="item"> {{item}}</mat-option>
          </mat-select>
          <mat-error *ngIf="f.submitted || numberPhoneRe.invalid">
            <span class="text-error" *ngIf="numberPhoneRe?.errors?.required">
              {{'validation.pls_select_phone' | translate}}
            </span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="center">
    <button mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button mat-raised-button type="submit" [disabled]="!selectedPhone" color="primary">
      <mat-icon class="mr-0">gesture</mat-icon>
      {{'button.sign' | translate}}
    </button>
  </mat-dialog-actions>
</form>